import { Component, OnInit } from '@angular/core';
import { AsyncPipe, NgClass } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { CreatePositionScore, Position as PositionEntity, Positions, PositionScore } from 'src/app/models';
import { ToastService, ContextService, LoadingService } from 'src/app/services'
import { ScrollingModule } from '@angular/cdk/scrolling';
import { MatButtonToggleModule } from '@angular/material/button-toggle';
import { MatProgressSpinnerModule } from "@angular/material/progress-spinner"

interface Position {
    masterId: string;
    name: string;
    score: number | null;
}

@Component({
    selector: 'valben-position-scores',
    standalone: true,
    imports: [MatProgressSpinnerModule, FormsModule, ScrollingModule, MatButtonToggleModule, AsyncPipe, NgClass],
    styles: [`
        :host {
            width: 100%;
            display: flex;
            flex-direction: column;
        }
    `],
    templateUrl: './position-scores.page.html',
})
export class PositionScoresPage implements OnInit {
    positionScores: Position[] = []
    unassignedPositions: Position[] = []
    shownPositionScores: Position[] = []
    shownUnassignedPositions: Position[] = []
    positionScoresVariants = [{ label: '5', score: 5 }, { label: '10', score: 10 }, { label: '15', score: 15 }]
    positionScoresLoading$ = this._loadingService.positionScoresLoading()
    unassignedPositionsLoading$ = this._loadingService.positionScoresLoading()

    constructor(
        private _context: ContextService,
        private _messageService: ToastService,
        private _loadingService: LoadingService,
    ) { }

    ngOnInit(): void {
        this._context.InitKngPositionScores()
        this._context.InitDependencies()

        this._context.getPositionScores().subscribe({
            next: (data) => {
                this._context.Positions().subscribe({
                    next: (positions: Positions | undefined) => {
                        if (!positions) {
                            return
                        }
                        const pos = [...positions.jobGroups, ...positions.workPlaces]
                        this.positionScores = data.map((score: PositionScore) => {
                            const position = pos.find(pos => pos.masterId === score.positionId)
                            return {
                                masterId: score.positionId,
                                name: position ? (position.names['hr'] || position.names['en'] || 'N/A') : 'N/A',
                                score: score.score
                            }
                        })
                        this.shownPositionScores = JSON.parse(JSON.stringify(this.positionScores))
                    },
                })
            }
        })

        this._context.getUnassignedPositions().subscribe({
            next: (data) => {
                this.unassignedPositions = data.map((pos: PositionEntity) => ({
                    masterId: pos.masterId,
                    name: pos.names['hr'] || pos.names['en'] || 'N/A',
                    score: null
                }))
                this.shownUnassignedPositions = JSON.parse(JSON.stringify(this.unassignedPositions))
            }
        })
    }

    assignPositionScore(position: Position) {
        if (position.score === null) {
            return
        }

        const createPositionScore: CreatePositionScore = {
            positionId: position.masterId,
            score: position.score
        }

        this._context.addPositionScore(createPositionScore).subscribe({
            next: () => {
                this._messageService.add({
                    severity: 'success',
                    summary: 'Uspješno dodano',
                    detail: `Bodovi za poziciju "${position.name}" su dodijeljeni.`,
                    life: 10000
                })
            },
            error: (err) => {
                this._messageService.add({
                    severity: 'error',
                    summary: 'Greška',
                    detail: err?.error?.message || 'Došlo je do greške prilikom dodavanja bodova.',
                    life: 10000
                });
            }
        });
    }
    toggleScore(position: Position, score: number): void {
        position.score = position.score === score ? null : score
    }

    changePositionScore(position: Position) {
        const currentPositionScore = this.positionScores.find(pos => pos.masterId === position.masterId)
        if (currentPositionScore?.score === position.score) {
            this._messageService.add({
                severity: 'info',
                summary: 'Nema promjene',
                detail: `Pozicija "${position.name}" je već ocijenjena s ${position.score} bodova.`,
                life: 10000
            });
            return
        }

        const updatedPositionScore: PositionScore = {
            positionId: position.masterId,
            score: position.score!,
            masterId: '',
            createdByUser: '',
            modifiedByUser: '',
            createdDate: new Date(),
            modifiedDate: new Date(),
            version: 1
        }

        this._context.updatePositionScore(updatedPositionScore).subscribe({
            next: () => {
                this._messageService.add({
                    severity: 'info',
                    summary: 'Ažurirano',
                    detail: `Bodovi za poziciju "${position.name}" su ažurirani.`,
                    life: 10000
                });
            },
            error: (err) => {
                this._messageService.add({
                    severity: 'error',
                    summary: 'Greška',
                    detail: err?.error?.message || 'Došlo je do greške prilikom ažuriranja bodova.',
                    life: 10000
                });
            }
        });
    }

    filterPositions(event: any) {
        const query = event.target.value.toLowerCase()
        this.shownPositionScores = this.positionScores.filter(pos => pos.name.toLowerCase().includes(query))
    }

    filterUnassignedPositions(event: any) {
        const query = event.target.value.toLowerCase()
        this.shownUnassignedPositions = this.unassignedPositions.filter(pos => pos.name.toLowerCase().includes(query))
    }
}
